import { useEffect, useState } from "react";
import { AnimatePresence, motion, MotionConfig } from "framer-motion";
import SplashCover from "./components/SplashCover";
import TopNav from "./components/TopNav";
import Hero from "./components/Hero";
import Timeline from "./components/Timeline";
import Skills from "./components/Skills";
import Contact from "./components/Contact";
import BottomBar from "./components/BottomBar";
import GridPulses from "./components/GridPulses";
import GridIntro from "./components/GridIntro";
import { EnteredContext } from "./EnteredContext";
import { profile } from "./data/profile";
import { timeline, categories } from "./data/timeline";
import { skills } from "./data/skills";
import "./App.css";

const NAV_SECTIONS = [
  { id: "about", label: "About" },
  { id: "timeline", label: "Timeline" },
  { id: "skills", label: "Skills" },
  { id: "contact", label: "Contact" },
];

export default function App() {
  const [entered, setEntered] = useState(false);
  // True once the splash has fully opened — this starts the grid intro.
  const [revealed, setRevealed] = useState(false);
  // True once the grid intro (draw + pulse) finishes — this lights the resting
  // grid AND is the cue for all the text to load in.
  const [lit, setLit] = useState(false);

  // Always start the intro at the top, and don't let the browser restore a
  // previous scroll position on refresh.
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
  }, []);

  // Until the intro finishes (`lit`): lock scrolling and hide the site so
  // nothing appears/animates behind the intro. Then reveal + light the grid.
  useEffect(() => {
    document.documentElement.classList.toggle("site-locked", !lit);
    document.body.classList.toggle("site-locked", !lit);
    document.body.classList.toggle("grid-lit", lit);
    if (!lit) window.scrollTo(0, 0);
  }, [lit]);

  return (
    <EnteredContext.Provider value={lit}>
      <MotionConfig reducedMotion="user">
        <GridPulses />
        {revealed && <GridIntro onComplete={() => setLit(true)} />}
        <AnimatePresence onExitComplete={() => setRevealed(true)}>
        {!entered && (
          <motion.div
            key="splash"
            className="splash-layer"
            initial="closed"
            animate="closed"
            exit="open"
          >
            <SplashCover profile={profile} onEnter={() => setEntered(true)} />
          </motion.div>
        )}
      </AnimatePresence>

      <TopNav sections={NAV_SECTIONS} />

      <main className="site">
        <Hero profile={profile} />
        <Timeline timeline={timeline} categories={categories} />
        <Skills skills={skills} />
        <Contact profile={profile} />
      </main>

      <BottomBar />
      </MotionConfig>
    </EnteredContext.Provider>
  );
}
